import React, { Component } from "react";
import CartContext from "./CartContext";
import { Navigate } from "react-router-dom";
import ReactDOM from "react-dom";
import axios from "axios";
import "../CSS/3d.css";
import Swal from "sweetalert2";
import PosInvoiceTemplate from "./PosInvoice.txt";
import { Country, State } from "country-state-city";
import { LoadSpinner } from "./LoadSpinner";

import {
  FloatingLabel,
  Button,
  Table,
  Modal,
  Form,
  Row,
  Col,
  Badge,
  Stack,
  Card,
} from "react-bootstrap";

export default class CheckoutPOS extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      registeredUserAccount: "",
      guestUserAccount: "",
      firstName: "",
      lastName: "",
      emailId: "",
      mobileNo: "",
      address: "",
      landmark: "",
      country: "",
      state: "",
      city: "",
      pinCode: "",
      paymentmode: "",
      formValidationErrorMsg: "",
      validatedAndSubmitted: "false",
      errormsg: "",
      loadSpinnerOpen: false,
      hideDifferentAddress: "true",
      deliveryAddressState: "current", //current or different
      showCodModal: false,
      showPayByCashModal: false,
      showPayByQrCodeModal: false,
      showPayByCardSwipingMachineModal: false,
      orderTypeOrderDelivered: this.props.orderTypeOrderDelivered,
      orderTypeTakeAway: this.props.orderTypeTakeAway,
      orderTypeHomeDelivery: this.props.orderTypeHomeDelivery,
      razorPayWindow: "",
      quickPayEvent: false,

      // UX toggles
      step: 1,
      ignoreCustomerData: false,
      deliverToBillingAddress: false,
      gstInvoiceRequested: false,
    };
    this.keyMap = { TEST1: "t" };
  }

  SetGstInvoiceRequest = (value) => {
    this.setState({ gstInvoiceRequested: value }, () => {});
  };

  // ===== Helpers
  digitsOnly = (value, maxLen = 10) => {
    const onlyDigits = (value || "").replace(/\D/g, "");
    return onlyDigits.slice(0, maxLen);
  };

  static PaymentMode_CashOnDelivery = 1;
  static PaymentMode_RazorPay = 2;
  static OrderStatusRecived = 1;

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name.trim()) {
      case "firstName":
        this.setState({ firstName: value });
        break;
      case "mobileNo":
        this.setState({ mobileNo: this.digitsOnly(value, 10) });
        break;
      case "emailId":
        this.setState({ emailId: value });
        break;
      case "address":
        this.setState({ address: value });
        break;
      default:
        break;
    }
  };

  // ===== Payments
  CallRazorPay = () => {
    var ordid = "Order_" + new Date().getTime();
    var options = {
      key: this.context.storeSettings.razorpayKey,
      key_secret: this.context.storeSettings.razorpayKeySecret,
      amount:
        Math.round(
          this.context.getTotalAmountWithTax(
            this.context.getPOSCartByName(this.context.selectedPOS),
            this.props.coupon.couponValue
          ),
          0
        ) * 100,
      currency: this.context.storeSettings.razorpayCurrency,
      name: this.context.storeSettings.razorpayCompanyName,
      description: this.context.storeSettings.razorpayCompanyDescription,
      orderid: ordid,
      handler: (response) => this.SuccessRazorPayResponse(response),
      prefill: { name: "", email: "", contact: "" },
      notes: { address: this.context.storeSettings.razorpayCompanyAddress },
      theme: { color: this.context.storeSettings.razorpayThemeColor },
      modal: { escape: false, ondismiss: () => {} },
    };
    var pay = window.Razorpay(options);
    pay.on("payment.failed", (response) =>
      this.FailedInRazorPayResponse(response)
    );
    pay.open();
  };
  FailedInRazorPayResponse = () => {};
  SuccessRazorPayResponse = (response) => {
    this.StoreOrderInDB(response.razorpay_payment_id);
  };

  // ===== Printing / Invoices (unchanged logic)
  ConvertProductNamesTo2ndLanguage = (orderData) => {
    for (let i = 0; i < orderData.customerOrderedItems.length; i++) {
      var result = this.context.prodsAll.filter(
        (f) => f.name === orderData.customerOrderedItems[i].productName
      );
      if (result.length > 0 && result[0].name2)
        orderData.customerOrderedItems[i].productName = result[0].name2;
    }
  };

  PrintInvoiceOffline = (value) => {
    fetch(PosInvoiceTemplate)
      .then((r) => r.text())
      .then((htmltxt) => {
        htmltxt = htmltxt.replace("{{StoreName}}", this.context.store.name);
        htmltxt = htmltxt.replace(
          "{{StoreAddress}}",
          this.context.shippingDetails.address +
            ", " +
            this.context.shippingDetails.city +
            ", " +
            this.context.shippingDetails.state +
            ", " +
            this.context.shippingDetails.pincode
        );
        if (
          this.context.storeSettings.storeEmailId != null &&
          this.context.storeSettings.storeEmailId !== ""
        )
          htmltxt = htmltxt.replace(
            "{{StoreEmailid}}",
            this.context.storeSettings.storeEmailId
          );
        else htmltxt = htmltxt.replace("{{StoreEmailid}}", "");
        if (
          this.context.storeSettings.storePhoneNo != null &&
          this.context.storeSettings.storePhoneNo !== ""
        )
          htmltxt = htmltxt.replace(
            "{{StoreContact}}",
            "+" +
              this.context.storeSettings.defaultCountryCode +
              "-" +
              this.context.storeSettings.storePhoneNo
          );
        else htmltxt = htmltxt.replace("{{StoreContact}}", "");
        htmltxt = htmltxt.replace("{{Order_No}}", value.orderId);
        htmltxt = htmltxt.replace(
          "{{Order_Date}}",
          this.context.GetInDateFormat(new Date())
        );

        var orderedItems = "";
        var totqty = 0;
        for (var i = 0; i < value.customerOrderedItems.length; i++) {
          orderedItems += "<tr>";
          if (value.customerOrderedItems[i].discount > 0)
            orderedItems +=
              '<td align="start">' +
              value.customerOrderedItems[i].productName +
              "[MRP.₹" +
              Number(value.customerOrderedItems[i].mrp).toFixed(1) +
              " " +
              value.customerOrderedItems[i].discount +
              "% OFF]" +
              "</td>";
          else
            orderedItems +=
              '<td align="start">' +
              value.customerOrderedItems[i].productName +
              "</td>";

          orderedItems +=
            "<td>" +
            Number(
              value.customerOrderedItems[i].mrp -
                (value.customerOrderedItems[i].mrp *
                  value.customerOrderedItems[i].discount) /
                  100
            ).toFixed(1) +
            "</td>";

          orderedItems += "<td>" + value.customerOrderedItems[i].qty + "</td>";

          orderedItems +=
            '<td align="end">' +
            Number(
              (value.customerOrderedItems[i].mrp -
                (value.customerOrderedItems[i].mrp *
                  value.customerOrderedItems[i].discount) /
                  100) *
                value.customerOrderedItems[i].qty
            ).toFixed(1) +
            "</td>";
          totqty += Number(value.customerOrderedItems[i].qty);
          orderedItems += "</tr>";
        }

        htmltxt = htmltxt.replace("{{Ordered_Items}}", orderedItems);
        htmltxt = htmltxt.replace("{{TotalQty}}", Number(totqty).toFixed(1));
        htmltxt = htmltxt.replace(
          "{{subtotal}}",
          "₹" + Number(value.subTotalAmt).toFixed(1)
        );

        var extracharges = "";
        if (value.couponValue > 0)
          extracharges += "Coupon Value: ₹" + value.couponValue + "<br/>";
        if (value.deliveryAmt > 0)
          extracharges +=
            "Delivery Charges: ₹" +
            Number(value.deliveryAmt).toFixed(1) +
            "<br/>";
        if (value.taxPercentage > 0) {
          if (this.context.store.businessTypeId == 3) {
            extracharges +=
              "CGST " +
              value.taxPercentage / 2 +
              "%: &nbsp;&nbsp;&nbsp; ₹" +
              Number(value.taxAmount / 2).toFixed(1) +
              "<br/>";
            extracharges +=
              "SGST " +
              value.taxPercentage / 2 +
              "%: &nbsp;&nbsp;&nbsp;₹" +
              Number(value.taxAmount / 2).toFixed(1) +
              "<br/>";
          } else {
            extracharges +=
              "Taxes(" +
              value.taxPercentage +
              "%): ₹" +
              Number(value.taxAmount).toFixed(1) +
              "<br/>";
          }
        }
        htmltxt = htmltxt.replace("{{Extra_charges}}", extracharges);
        htmltxt = htmltxt.replace(
          "{{GrandTotal}}",
          "Total= ₹" + Number(value.totalAmt).toFixed(1)
        );
        if (value.totalSavings > 0)
          htmltxt = htmltxt.replace(
            "{{Savings}}",
            "Savings= ₹" + Number(value.totalSavings).toFixed(1)
          );
        else htmltxt = htmltxt.replace("{{Savings}}", "");

        if (
          this.context.storeSettings.homeDeliveryDomainAddress !== "" &&
          this.context.storeSettings.homeDeliveryDomainAddress != null
        )
          htmltxt = htmltxt.replace(
            "{{homedeliveryaddress}}",
            "Delivery: <b>" +
              this.context.storeSettings.homeDeliveryContactNumber +
              "  " +
              this.context.storeSettings.homeDeliveryDomainAddress +
              "</b>"
          );
        else htmltxt = htmltxt.replace("{{homedeliveryaddress}}", "");

        this.PrintTableOffline(htmltxt);
      });
  };

  PrintTableOffline = (invoiceHtml) => {
    var printWindow = window.open("", "_blank");
    printWindow.document.write(invoiceHtml);
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };

  GetPosInvoiceHtml = (orderData) => {
    if (this.context.storeSettings.printPosBillIn2NdLanguage === true)
      this.ConvertProductNamesTo2ndLanguage(orderData);

    axios
      .post(
        process.env.REACT_APP_API + "Consumers/GetPosInvoiceHtml/",
        orderData
      )
      .then((response) => {
        if (response.status === 200) this.PrintTable(response.data);
      })
      .catch((error) => console.error("GetInvoiceHtml error: ", error));
  };

  GetGstInvoiceHtml = (orderData) => {
    if (this.context.storeSettings.printPosBillIn2NdLanguage === true)
      this.ConvertProductNamesTo2ndLanguage(orderData);

    axios
      .post(
        process.env.REACT_APP_API + "Consumers/GetGstInvoiceHtml/",
        orderData
      )
      .then((response) => {
        if (response.status === 200) this.PrintTable(response.data);
      })
      .catch((error) => console.error("GetInvoiceHtml error: ", error));
  };

  PrintTable = (invoiceHtml) => {
    var printWindow = window.open("", "_blank");
    printWindow.document.write(invoiceHtml);
    printWindow.document.close();
    setTimeout(() => {
      this.onPrintFinished(printWindow.print(), printWindow);
    }, 250);
  };

  getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";
    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  onPrintFinished = (status, printWindow) => {
    if (this.getOS() === "Windows") printWindow.close();
  };

  getMainCategoryById = (id) => {
    var pg = this.context.mainCategories.filter((e) => e.id === id);
    return pg.length > 0 ? pg[0].name : "";
  };

  GetOfflineOrderId = () => {
    var d = new Date();
    var month = (d.getMonth() + 1).toString().padStart(2, "0");
    var day = d.getDate().toString().padStart(2, "0");
    var year = d.getFullYear().toString().substr(-2);
    var hh = d.getHours().toString();
    var mm = d.getMinutes().toString();
    var ss = d.getSeconds().toString();
    return this.context.pcCode + year + month + day + hh + mm + ss;
  };

  ValidateCART = () => {
    var cart = this.context.getPOSCartByName(this.context.selectedPOS);
    for (var i = 0; i < cart.length; i++) {
      if (!(cart[i].prod.mrp > 0 && cart[i].qty > 0)) return false;
    }
    return true;
  };

  GetProductNameDetailed = (prod, pieceCount) => {
    var result = prod.name;
    if (pieceCount > 0)
      result +=
        window.location.hostname === "sharoffsteel-pos.elasticcart.com"
          ? " Pieces: " + pieceCount
          : "";
    if (prod.hsncode) result += " HSNCode: " + prod.hsncode;
    if (prod.batchId)
      result +=
        window.location.hostname === "sharoffsteel-pos.elasticcart.com"
          ? " CoilId: " + prod.batchId
          : " BatchId: " + prod.batchId;
    if (prod.qualityId)
      result +=
        window.location.hostname === "sharoffsteel-pos.elasticcart.com"
          ? " Test Report No: " + prod.qualityId
          : " QualityId: " + prod.qualityId;
    return result;
  };

  // Minimal redeem call (throws on HTTP error)
  callRedeem = async ({ storeId, customerId, pointsToRedeem, referenceId }) => {
    try {
      const payload = {
        storeId,
        customerId,
        pointsToRedeem: Number(pointsToRedeem || 0),
        referenceId: referenceId || undefined,
        reason: "Redeem at POS",
      };

      const url = `${process.env.REACT_APP_API}loyalty/redeem`;
      const res = await axios.post(url, payload);
      const data = res?.data || {};

      return {
        success: data.success === true,
        discountAmount: Number(data.discountAmount || 0),
        balanceAfter: data.balanceAfter ?? null,
        raw: data,
      };
    } catch (err) {
      console.error("callRedeem error:", err);
      throw {
        message:
          err?.response?.data?.message ||
          err?.response?.data ||
          err.message ||
          "Redeem failed",
        raw: err,
      };
    }
  };

  callEarn = async ({
    storeId,
    customerId,
    orderId,
    orderAmount,
    referenceId,
    reason,
  }) => {
    try {
      const payload = {
        storeId,
        customerId,
        orderId: orderId || null,
        orderAmount: Number(orderAmount || 0),
        referenceId: referenceId || undefined,
        reason: reason || "Earn from POS order",
      };

      const url = `${process.env.REACT_APP_API}loyalty/earn`;
      const res = await axios.post(url, payload);
      const data = res?.data || {};

      return {
        success: data.success === true,
        pointsGranted: Number(data.pointsGranted || 0),
        balanceAfter: data.balanceAfter ?? null,
        raw: data,
      };
    } catch (err) {
      console.error("callEarn error:", err);
      throw {
        message:
          err?.response?.data?.message ||
          err?.response?.data ||
          err.message ||
          "Earn failed",
        raw: err,
      };
    }
  };

  StoreOrderInDB = async (paymentTransactionId) => {
    // helper: normalize numeric (2 decimal places)
    const toDecimal = (v) => {
      const n = Number(v || 0);
      return Math.round(n * 100) / 100;
    };

    // helper: try to find product-level GST percentage from context.prods
    const getProductGstFromContext = (productId) => {
      const prods = this.context.prods;
      const found = prods.find((p) => p.id === productId);
      if (!found) return null;

      const raw = found.gst;
      const asNum = Number(raw);
      return isNaN(asNum) ? null : asNum;
    };

    // guard: ensure store-level tax percentage exists as number
    const storeTaxPct = Number(this.context.taxDetails?.taxPercentage || 0);
    const storeInclusive = !!this.context.taxDetails?.inclusiveOfTax;

    // validate cart
    if (!this.ValidateCART()) {
      Swal.fire({
        title: "Invalid CART!",
        text: "Price and Qty should be greater than 0. Please fix the errors in the Cart and proceed!",
        confirmButtonText: "ok",
      });
      this.props.SetQuickPayEventFalse();
      return;
    }

    // guard reentrancy
    if (!this.context.isOfflineMode && this.context.submitOrderInProgress)
      return;
    this.context.SetSubmitOrderInProgress(true);

    // Build ordered items
    let orderTaxAmount = 0; // internal accumulator

    const customerOrderedItems = this.context
      .getPOSCartByName(this.context.selectedPOS)
      .map((cartItem) => {
        const productId =
          cartItem.prod.id && !cartItem.prod.id.includes("Custom")
            ? cartItem.prod.id
            : undefined;

        // --- GST selection per your rule ---
        // If store is configured inclusive -> use product-level GST from this.context.prods
        // If store is configured exclusive -> use store-level taxPercentage
        let gstPct = 0;
        let inclusiveOfTax = false;

        if (storeInclusive) {
          // inclusive store: use product GST (no fallback to store tax)
          const prodGst = getProductGstFromContext(productId);
          gstPct = prodGst != null ? Number(prodGst) : 0;
          inclusiveOfTax = true;
        } else {
          // exclusive store: use store tax %
          gstPct = storeTaxPct;
          inclusiveOfTax = false;
        }

        gstPct = toDecimal(gstPct);

        // INTERNAL: compute GST amount for orderTaxAmount only (NOT stored on item payload)
        const mrp = Number(cartItem.prod.mrp || 0);
        const discount = Number(cartItem.prod.discount || 0);
        const qty = Number(cartItem.qty || 0);
        const lineBase = toDecimal((mrp - (mrp * discount) / 100) * qty);

        let gstAmountInternal = 0;
        if (gstPct > 0) {
          if (inclusiveOfTax) {
            // price includes GST — extract GST portion
            gstAmountInternal = toDecimal((lineBase * gstPct) / (100 + gstPct));
          } else {
            // price excludes GST — GST on top
            gstAmountInternal = toDecimal((lineBase * gstPct) / 100);
          }
        }

        orderTaxAmount = toDecimal(orderTaxAmount + gstAmountInternal);

        // PAYLOAD: only camelCase fields that match your model
        return {
          productId: productId,
          productName: cartItem.prod.name,
          categoryName: this.getMainCategoryById(cartItem.prod.mainCategoryId),
          imgFileName: cartItem.prod.imgFileName,
          mrp: cartItem.prod.mrp,
          discount: cartItem.prod.discount,
          qty: cartItem.qty,
          pieceCount: cartItem.pieceCount,
          description: cartItem.prod.description,
          salesOrderId: cartItem.salesOrderId,
          gst: gstPct,
          inclusiveOfTax: inclusiveOfTax,
        };
      });

    const customerOrderDeliveryAddresses = [
      {
        firstName: this.state.firstName,
        lastName: "",
        mobileNo: this.state.mobileNo,
        emailId: this.state.emailId,
        Address: this.state.address,
        Landmark: "",
        city: this.state.city,
        state: this.state.state,
        country: this.state.country,
        pinCode: this.state.pinCode,
        gstno: this.state.gstno,
      },
    ];

    // payment / order status logic remains unchanged
    const paymentmodeid = this.state.paymentmode;
    let paymentstatusid = 0;
    let orderstatusid = 0;
    let deliveryMethodId = 0;
    let totalAmtPaid = 0;

    if (this.state.orderTypeOrderDelivered) {
      paymentstatusid = paymentmodeid === 6 ? 2 : 1;
      orderstatusid = paymentmodeid === 6 ? 8 : 11;
      deliveryMethodId = 1;
      if (paymentmodeid !== 6) {
        totalAmtPaid = this.context.getTotalAmountWithTax(
          this.context.getPOSCartByName(this.context.selectedPOS),
          this.props.coupon.couponValue
        );
      }
    } else if (this.state.orderTypeTakeAway) {
      if (paymentmodeid === 1) {
        paymentstatusid = 2;
        orderstatusid = 2;
        deliveryMethodId = 2;
      } else {
        paymentstatusid = 1;
        orderstatusid = 2;
        deliveryMethodId = 2;
        totalAmtPaid = this.context.getTotalAmountWithTax(
          this.context.getPOSCartByName(this.context.selectedPOS),
          this.props.coupon.couponValue
        );
      }
    } else if (this.state.orderTypeHomeDelivery) {
      paymentstatusid = 2;
      orderstatusid = 2;
      deliveryMethodId = 3;
      totalAmtPaid = 0;
    }

    // loyalty (unchanged)
    const loyaltyPayload = this.state.loyaltyPayload || {
      pointsRedeemed: 0,
      loyaltyDiscountAmount: 0,
      loyaltyReferenceId: "",
    };
    const pointsRedeemed = toDecimal(
      Number(loyaltyPayload.pointsRedeemed || 0)
    );
    let loyaltyDiscount = toDecimal(
      Number(loyaltyPayload.loyaltyDiscountAmount || 0)
    );
    const loyaltyReferenceId = loyaltyPayload.loyaltyReferenceId || "";

    const baseTotal = this.context.getTotalAmountWithTax(
      this.context.getPOSCartByName(this.context.selectedPOS),
      this.props.coupon.couponValue
    );

    let totalSavingsClient = toDecimal(
      this.context.getTotalSavingsFromCart(
        this.context.getPOSCartByName(this.context.selectedPOS)
      ) + loyaltyDiscount
    );

    // PAYLOAD (camelCase)
    const orderPayload = {
      storeId: this.context.storeId,
      orderCreated: this.context.isOfflineMode
        ? new Date().toISOString()
        : null,
      orderModified: this.context.isOfflineMode
        ? new Date().toISOString()
        : null,
      orderId: this.context.isOfflineMode ? this.GetOfflineOrderId() : null,
      customerId: this.context.userData?.id || null,
      billingCustomerId: this.state.billingCustomerId || null,
      paymentModeId: paymentmodeid,
      paymentStatusId: paymentstatusid,
      deliveryMethodId: deliveryMethodId,
      paymentTransactionId: paymentTransactionId,
      orderStatus: orderstatusid,
      description: "",
      orderWorkflowStatus: `<p>${this.context.GetInDateFormat(new Date())}=> ${
        this.state.orderTypeOrderDelivered ? "POS-PaidAndClosed" : "Received"
      }</p>`,
      subTotalAmt: toDecimal(
        this.context.getSubTotalPriceInCart(
          this.context.getPOSCartByName(this.context.selectedPOS)
        )
      ),
      deliveryAmt: toDecimal(
        this.context.getDeliveryAmount(
          this.context.getPOSCartByName(this.context.selectedPOS)
        )
      ),
      totalAmt: toDecimal(Math.max(0, Number(baseTotal) - loyaltyDiscount)),
      totalAmtPaid: toDecimal(totalAmtPaid),
      couponCode: this.props.coupon?.couponCode || "",
      couponValue: toDecimal(this.props.coupon?.couponValue || 0),
      totalSavings: toDecimal(totalSavingsClient),

      // preserve existing taxPercentage behavior for compatibility:
      // send 0 when store configured inclusive (same as before), otherwise send store-level %
      taxPercentage: this.context.taxDetails.inclusiveOfTax
        ? 0
        : this.context.taxDetails.taxPercentage,

      // send computed order-level taxAmount (sum of per-line gst amounts)
      taxAmount: toDecimal(orderTaxAmount),

      customerOrderedItems,
      customerOrderDeliveryAddresses,

      // loyalty
      pointsRedeemed: pointsRedeemed,
      loyaltyDiscountAmount: loyaltyDiscount,
      loyaltyReferenceId: loyaltyReferenceId,
    };

    // offline flow
    if (this.context.isOfflineMode === true) {
      this.context.AddOfflineOrders(orderPayload);
      this.PrintInvoiceOffline(orderPayload);
      this.context.ClearCartAndOrderDetails(this.context.selectedPOS);
      this.props.StoreCouponDetails("", 0);
      this.HidePayByCashModal();
      this.HidePayByQrcodeModal();
      this.props.SetQuickPayEventFalse();
      window.scrollTo(0, 0);
      this.context.SetSubmitOrderInProgress(false);
      return;
    }

    // ONLINE: redeem -> submit -> earn
    try {
      this.ShowLoadSpinner();

      // derive billingCustomerId defensively
      const billingCustomerId =
        this.state.billingCustomerId ||
        this.state.customerDeliveryDetail?.id ||
        this.state.customerDetail?.id ||
        null;

      // Redeem (if requested)
      if (pointsRedeemed > 0) {
        if (!billingCustomerId) {
          this.HideLoadSpinner();
          this.context.SetSubmitOrderInProgress(false);
          Swal.fire({
            title: "No customer selected",
            text: "Cannot redeem points without a billing customer.",
            icon: "error",
          });
          return;
        }

        try {
          const redeemResp = await this.callRedeem({
            storeId: this.context.storeId,
            customerId: billingCustomerId,
            pointsToRedeem: pointsRedeemed,
            referenceId: loyaltyReferenceId,
          });

          // expect camelCase from backend
          if (!redeemResp || redeemResp.success !== true) {
            const msg = redeemResp?.raw || "Unable to redeem points.";
            this.HideLoadSpinner();
            this.context.SetSubmitOrderInProgress(false);
            Swal.fire({
              title: "Loyalty Redeem Failed",
              text: typeof msg === "string" ? msg : JSON.stringify(msg),
              icon: "error",
            });
            return;
          }

          // apply server-approved discount
          const serverDiscount = toDecimal(
            Number(redeemResp.discountAmount || 0)
          );
          loyaltyDiscount = serverDiscount;

          // update payload (server model names) and recalc totals
          orderPayload.LoyaltyDiscountAmount = loyaltyDiscount;
          orderPayload.PointsRedeemed = pointsRedeemed;

          // keep camelCase keys too
          orderPayload.loyaltyDiscountAmount = loyaltyDiscount;
          orderPayload.loyaltyPointsRedeemed = pointsRedeemed;
          orderPayload.loyaltyReferenceId = loyaltyReferenceId;

          orderPayload.totalAmt = toDecimal(
            Math.max(0, Number(baseTotal) - loyaltyDiscount)
          );
          orderPayload.totalSavings = toDecimal(
            this.context.getTotalSavingsFromCart(
              this.context.getPOSCartByName(this.context.selectedPOS)
            ) + loyaltyDiscount
          );
        } catch (redeemErr) {
          this.HideLoadSpinner();
          this.context.SetSubmitOrderInProgress(false);
          const text =
            redeemErr?.message ||
            JSON.stringify(redeemErr?.raw || redeemErr) ||
            "Redeem failed. Please try again.";
          Swal.fire({ title: "Loyalty Redeem Failed", text, icon: "error" });
          console.error("Redeem error:", redeemErr);
          return;
        }
      }

      // Submit order to backend
      try {
        const submitRes = await axios.post(
          `${process.env.REACT_APP_API}Consumers/SubmitOrder`,
          orderPayload
        );

        if (!(submitRes && submitRes.status === 200)) {
          this.HideLoadSpinner();
          this.context.UpdateOrderStatus("Failed");
          this.props.SetQuickPayEventFalse();
          this.context.SetSubmitOrderInProgress(false);
          Swal.fire({
            title: "Failed!",
            text: "Order Submit Failed. Please try again!",
            confirmButtonText: "ok",
          });
          return;
        }

        // success path
        const orderResponse = submitRes.data;
        this.HideLoadSpinner();
        this.context.SetLastBillAmount(orderResponse.totalAmt);
        this.context.storeOrderInformation(orderResponse);
        this.SendInvoiceEmail(orderResponse);
        if (this.state.gstInvoiceRequested === true)
          this.GetGstInvoiceHtml(orderResponse);
        else this.GetPosInvoiceHtml(orderResponse);
        this.context.ClearCartAndOrderDetails(this.context.selectedPOS);
        this.context.setDeliveryCost(0);
        this.props.StoreCouponDetails("", 0);
        this.HidePayByCashModal();
        this.HidePayByQrcodeModal();
        this.props.SetQuickPayEventFalse();
        this.context.SetSubmitOrderInProgress(false);
        this.setState({ loyaltyPayload: null });
        window.scrollTo(0, 0);

        // Earn points (best-effort)
        try {
          const earnCustomerId = billingCustomerId;
          if (earnCustomerId) {
            const earnResp = await this.callEarn({
              storeId: this.context.storeId,
              customerId: earnCustomerId,
              orderId: orderResponse.orderId || null,
              orderAmount: orderResponse.totalAmt ?? baseTotal,
              referenceId: `earn_${
                orderResponse.orderId || new Date().getTime()
              }`,
              reason: "Order Earn",
            });

            // optionally refresh loyalty balance
            try {
              const bal = await this.getLoyaltyBalance(earnCustomerId);
              if (bal && this.context.updateCustomerLoyalty)
                this.context.updateCustomerLoyalty(bal);
            } catch (refreshErr) {
              console.warn("Loyalty balance refresh failed:", refreshErr);
            }
          } else {
            console.warn("No billingCustomerId — skipping loyalty earn call.");
          }
        } catch (earnErr) {
          // earn is non-blocking
          console.error("Loyalty earn failed (non-blocking):", earnErr);
        }
      } catch (submitErr) {
        this.HideLoadSpinner();
        this.context.UpdateOrderStatus("Failed");
        this.props.SetQuickPayEventFalse();
        this.context.SetSubmitOrderInProgress(false);
        Swal.fire({
          title: "Failed!",
          text: "Order Submit Failed. Please try again!",
          confirmButtonText: "ok",
        });
        console.error("SubmitOrder error:", submitErr);
        return;
      }
    } catch (err) {
      this.HideLoadSpinner();
      this.context.UpdateOrderStatus("Failed");
      this.props.SetQuickPayEventFalse();
      this.context.SetSubmitOrderInProgress(false);
      Swal.fire({
        title: "Failed!",
        text: "Order Submit Failed. Please try again!",
        confirmButtonText: "ok",
      });
      console.error("StoreOrderInDB error:", err);
      return;
    } finally {
      this.HideLoadSpinner();
      this.context.SetSubmitOrderInProgress(false);
    }
  };

  SendInvoiceEmail = (data) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };
    fetch(
      process.env.REACT_APP_API + "Consumers/SendInvoiceEmail/" + "POS",
      requestOptions
    ).catch((error) => console.error("SendInvoiceEmail error:", error));
  };

  // ===== Payment button handlers
  OnCOD = () => this.ShowCodModal();
  handlePayByCash = () => {
    if (this.ValidateCustomerDetails() === false) return;
    this.ShowPayByCashModal();
  };
  handlePayViaQrcode = () => {
    if (this.ValidateCustomerDetails() === false) return;
    this.ShowPayByQrCodeModal();
  };
  handlePayBySwipingMachine = () => {
    if (this.ValidateCustomerDetails() === false) return;
    this.ShowPayCardSwipingMachineModal();
  };
  handleRazorPaySubmit = () => {
    if (this.ValidateCustomerDetails() === false) return;
    this.setState({ paymentmode: 2 }, () => this.CallRazorPay());
  };
  OnPayWithInvoice = () => {
    if (this.ValidateCustomerDetails() === false) return;
    this.setState({ paymentmode: 6 }, () => this.StoreOrderInDB(""));
  };

  updateCustomerDetails = (customerDetail) => {
    if (!customerDetail) return;
    this.setState({
      firstName: customerDetail.firstName,
      mobileNo: customerDetail.mobileNo,
      emailId: customerDetail.emailId,
      address: customerDetail.address,
      city: customerDetail.city,
      state: customerDetail.state,
      country: customerDetail.country,
      pinCode: customerDetail.pinCode,
      gstno: customerDetail.gstno,
    });
  };

  OnCodPaid = (customerDeliveryDetail, billingCustomerId, loyalty = null) => {
    this.updateCustomerDetails(customerDeliveryDetail);
    this.setState(
      { billingCustomerId, paymentmode: 1, loyaltyPayload: loyalty || null },
      () => this.StoreOrderInDB("")
    );
  };
  OnCashPaid = (customerDeliveryDetail, billingCustomerId, loyalty = null) => {
    this.updateCustomerDetails(customerDeliveryDetail);
    this.setState(
      { billingCustomerId, paymentmode: 3, loyaltyPayload: loyalty || null },
      () => this.StoreOrderInDB("")
    );
  };
  OnQrcodePaid = (
    customerDeliveryDetail,
    billingCustomerId,
    loyalty = null
  ) => {
    this.updateCustomerDetails(customerDeliveryDetail);
    this.setState(
      { billingCustomerId, paymentmode: 4, loyaltyPayload: loyalty || null },
      () => this.StoreOrderInDB("")
    );
  };
  OnCardSwipingMachinePaid = (
    customerDeliveryDetail,
    billingCustomerId,
    loyalty = null
  ) => {
    this.updateCustomerDetails(customerDeliveryDetail);
    this.setState(
      { billingCustomerId, paymentmode: 5, loyaltyPayload: loyalty || null },
      () => this.StoreOrderInDB("")
    );
  };

  // ===== Modals
  ShowCodModal = () => this.setState({ showCodModal: true, step: 3 });
  HideCodModal = () => this.setState({ showCodModal: false });
  ShowPayByCashModal = () =>
    this.setState({ showPayByCashModal: true, step: 3 });
  HidePayByCashModal = () => this.setState({ showPayByCashModal: false });
  ShowPayByQrCodeModal = () =>
    this.setState({ showPayByQrCodeModal: true, step: 3 });
  HidePayByQrcodeModal = () => this.setState({ showPayByQrCodeModal: false });
  ShowPayCardSwipingMachineModal = () =>
    this.setState({ showPayByCardSwipingMachineModal: true, step: 3 });
  HidePayByCardSwipingMachineModal = () =>
    this.setState({ showPayByCardSwipingMachineModal: false });

  OnCancelSale = () => {
    Swal.fire({
      title: "Are you sure wanted to Cancel the Sale?",
      showDenyButton: true,
      confirmButtonText: "yes",
    }).then((result) => {
      if (result.isConfirmed) {
        this.context.ClearCartAndOrderDetails(this.context.selectedPOS);
        window.scrollTo(0, 0);
      }
    });
  };

  _handleNVEvent = (event) => {
    if (event.key === "F9") this.setState({ showPayByCashModal: true });
  };
  componentDidMount() {
    if (this.props.quickPayEventSent === true)
      this.setState({ quickPayEvent: true });

    if (window.innerWidth >= 900) {
      ReactDOM.findDOMNode(this).addEventListener(
        "keydown",
        this._handleNVEvent
      );
      ReactDOM.findDOMNode(this).addEventListener("keyup", this._handleNVEvent);
    }
    window.scrollTo(0, 0);
  }

  // ===== Validation
  ValidateCustomerDetails = () => {
    if (this.state.orderTypeHomeDelivery === true) {
      if (this.state.firstName === "" || this.state.mobileNo === "") {
        Swal.fire({
          title: "warning!",
          text: "Customer Name and Mobile Number are mandatory!",
          timer: 1500,
        });
        return false;
      }
    }
    return true;
  };

  // ===== Render helpers (UX)
  StepIndicator = ({ step }) => (
    <div className="d-flex justify-content-center gap-3 my-2">
      <Badge bg={step >= 1 ? "primary" : "secondary"}>1. Customer</Badge>
      <Badge bg={step >= 2 ? "primary" : "secondary"}>2. Address</Badge>
      <Badge bg={step >= 3 ? "primary" : "secondary"}>3. Payment</Badge>
    </div>
  );

  SummaryStrip = () => {
    const items = this.context.getTotalQtyInCart(
      this.context.getPOSCartByName(this.context.selectedPOS)
    );
    const total = Math.round(
      this.context.getTotalAmountWithTax(
        this.context.getPOSCartByName(this.context.selectedPOS),
        this.props.coupon.couponValue
      ),
      0
    );
    const coupon = this.props.coupon?.couponCode
      ? `Coupon: ${this.props.coupon.couponCode} (-${this.props.coupon.couponValue})`
      : "No Coupon";
    return (
      <Card className="mb-2">
        <Card.Body className="py-2 d-flex justify-content-between">
          <div>
            <strong>Items:</strong> {items}
          </div>
          <div>
            <strong>Total:</strong>{" "}
            {total.toLocaleString(this.context.storeSettings.defaultLocale, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 1,
              style: "currency",
              currency: this.context.storeSettings.defaultCurrency,
            })}
          </div>
          <div className="text-muted">{coupon}</div>
        </Card.Body>
      </Card>
    );
  };

  render() {
    if (this.context.OrderStatus !== "") {
      return <Navigate to="/CompleteOrder" />;
    }
    if (this.state.quickPayEvent === true) {
      if (this.props.quickPayEventKey === "F8") {
        this.state.quickPayEvent = false; // must
        this.setState({ quickPayEvent: false }, () => this.OnCashPaid());
      } else if (this.props.quickPayEventKey === "F9") {
        this.state.quickPayEvent = false; // must
        this.props.SetQuickPayEventFalse();
        this.setState({ quickPayEvent: false }, () => this.OnQrcodePaid());
      }
    }

    return (
      <>
        {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : ""}

        {/* Payment modals (unchanged logic, enhanced UX inside component) */}
        {this.state.showCodModal ? (
          <PaymentTypeModal
            OnCodPaid={this.OnCodPaid}
            onHide={this.HideCodModal}
            coupon={this.props.coupon}
            StoreCouponDetails={this.props.StoreCouponDetails}
            show={this.state.showCodModal}
            paymentType="COD"
            SetGstInvoiceRequest={this.SetGstInvoiceRequest}
          />
        ) : (
          ""
        )}
        {this.state.showPayByCashModal ? (
          <PaymentTypeModal
            OnCashPaid={this.OnCashPaid}
            onHide={this.HidePayByCashModal}
            coupon={this.props.coupon}
            StoreCouponDetails={this.props.StoreCouponDetails}
            show={this.state.showPayByCashModal}
            paymentType="CASH"
            SetGstInvoiceRequest={this.SetGstInvoiceRequest}
          />
        ) : (
          ""
        )}
        {this.state.showPayByQrCodeModal ? (
          <PaymentTypeModal
            OnQrcodePaid={this.OnQrcodePaid}
            onHide={this.HidePayByQrcodeModal}
            coupon={this.props.coupon}
            StoreCouponDetails={this.props.StoreCouponDetails}
            show={this.state.showPayByQrCodeModal}
            paymentType="QRCODE"
            SetGstInvoiceRequest={this.SetGstInvoiceRequest}
          />
        ) : (
          ""
        )}
        {this.state.showPayByCardSwipingMachineModal ? (
          <PaymentTypeModal
            OnCardSwipingMachineModalPaid={this.OnCardSwipingMachinePaid}
            onHide={this.HidePayByCardSwipingMachineModal}
            coupon={this.props.coupon}
            StoreCouponDetails={this.props.StoreCouponDetails}
            show={this.state.showPayByCardSwipingMachineModal}
            paymentType="CARD"
            SetGstInvoiceRequest={this.SetGstInvoiceRequest}
          />
        ) : (
          ""
        )}

        {/* Desktop payment bar */}
        {window.innerWidth > 900 ? (
          <>
            <div
              className="m-0 p-0 border w-100"
              style={{ backgroundColor: this.context.posBackgroundColor }}
            >
              <table className="w-100 border-0 align-middle">
                {this.context.OrderStatus !== "Success" &&
                this.context.getTotalQtyInCart(
                  this.context.getPOSCartByName(this.context.selectedPOS)
                ) > 0 ? (
                  <>
                    {/* Home Delivery: show COD + Cancel */}
                    {this.state.orderTypeHomeDelivery && (
                      <tr>
                        <td className="col-md-3"></td>
                        <td className="col-md-3"></td>
                        <td className="col-md-3 align-middle text-center">
                          <Button
                            variant="warning"
                            className="w-100 text-dark cardimage-round btn3d-warning py-1"
                            style={{ height: 36, fontSize: "13px" }}
                            onClick={this.OnCOD}
                          >
                            <b>COD/Credit</b>
                          </Button>
                        </td>
                        <td className="col-md-3 align-middle text-end">
                          <Button
                            variant="danger"
                            className="btn3d-danger py-1"
                            size="sm"
                            onClick={this.OnCancelSale}
                          >
                            Cancel
                          </Button>
                        </td>
                      </tr>
                    )}

                    {/* In-store / TakeAway: color-coded buttons */}
                    {(this.state.orderTypeOrderDelivered ||
                      this.state.orderTypeTakeAway) && (
                      <tr>
                        {this.state.orderTypeTakeAway && (
                          <td className="align-middle text-center">
                            <Button
                              variant="warning"
                              className="text-dark w-100 cardimage-round btn3d-warning py-1"
                              style={{ height: 36, fontSize: "13px" }}
                              onClick={this.OnCOD}
                            >
                              <b>COD/Credit</b>
                            </Button>
                          </td>
                        )}
                        <td className="align-middle text-center">
                          <Button
                            variant="success"
                            className="text-dark w-100 cardimage-round btn3d-success py-1"
                            style={{ height: 36, fontSize: "13px" }}
                            onClick={this.handlePayByCash}
                          >
                            <i className="bi bi-cash"></i>&nbsp;<b>CASH (F8)</b>
                          </Button>
                        </td>
                        <td className="align-middle text-center">
                          <Button
                            variant="info"
                            className="text-dark w-100 cardimage-round btn3d-info py-1"
                            style={{ height: 36, fontSize: "13px" }}
                            onClick={this.handlePayViaQrcode}
                          >
                            <i className="bi bi-qr-code"></i>&nbsp;
                            <b>QR (F9)</b>
                          </Button>
                        </td>
                        <td className="align-middle text-center">
                          <Button
                            variant="primary"
                            className="text-white w-100 cardimage-round btn3d-primary py-1"
                            style={{ height: 36, fontSize: "13px" }}
                            onClick={this.handlePayBySwipingMachine}
                          >
                            <i className="bi bi-credit-card"></i>&nbsp;
                            <b>Card</b>
                          </Button>
                        </td>
                        {/* {this.state.orderTypeOrderDelivered && (
                          <td className="align-middle text-center">
                            <Button
                              variant="warning"
                              className="text-dark w-100 cardimage-round btn3d-warning py-1"
                              style={{ height: 36, fontSize: "13px" }}
                              onClick={this.OnCOD}
                            >
                              <b>Credit</b>
                            </Button>
                          </td>
                        )} */}
                        <td className="align-middle text-end">
                          <Button
                            variant="danger"
                            className="btn3d-danger py-1"
                            onClick={this.OnCancelSale}
                          >
                            Cancel
                          </Button>
                        </td>
                      </tr>
                    )}
                  </>
                ) : null}
              </table>
            </div>
          </>
        ) : (
          // Mobile bar (small but distinct)
          <div className="w-100 m-0 p-0">
            <Table className="w-100 p-0 m-0 border-0" size="sm">
              <tbody>
                {this.context.OrderStatus !== "Success" &&
                this.context.getTotalQtyInCart(
                  this.context.getPOSCartByName(this.context.selectedPOS)
                ) > 0 ? (
                  <>
                    {this.state.orderTypeHomeDelivery ? (
                      <tr className="w-100 p-0 m-0 border-0">
                        <td className="text-center border-0">
                          <Button
                            variant="warning"
                            className="text-dark cardimage-round btn3d-warning"
                            onClick={this.OnCOD}
                          >
                            COD/Credit
                          </Button>
                        </td>
                        <td className="text-end border-0">
                          <Button
                            variant="danger"
                            className="btn3d-danger"
                            onClick={this.OnCancelSale}
                          >
                            Cancel
                          </Button>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    {this.state.orderTypeOrderDelivered ||
                    this.state.orderTypeTakeAway ? (
                      <tr className="text-center border-0 p-0 m-0">
                        {this.state.orderTypeTakeAway ? (
                          <td className="text-center p-0 m-0 border-0">
                            <Button
                              variant="warning"
                              className="text-dark cardimage-round btn3d-warning"
                              onClick={this.OnCOD}
                            >
                              <b>COD/Credit</b>
                            </Button>
                          </td>
                        ) : (
                          <></>
                        )}
                        <td className="text-center p-0 m-0 border-0">
                          <Button
                            variant="success"
                            className="text-dark cardimage-round btn3d-success"
                            onClick={this.handlePayByCash}
                          >
                            <b>CASH</b>
                          </Button>
                        </td>
                        <td className="text-center p-0 m-0 border-0">
                          <Button
                            variant="info"
                            className="text-dark cardimage-round btn3d-info"
                            onClick={this.handlePayViaQrcode}
                          >
                            <b>QR</b>
                          </Button>
                        </td>
                        <td className="text-center p-0 m-0 border-0">
                          <Button
                            variant="primary"
                            className="text-white cardimage-round btn3d-primary"
                            onClick={this.handlePayBySwipingMachine}
                          >
                            <b>Card</b>
                          </Button>
                        </td>
                        <td className="text-end p-0 m-0 border-0">
                          <Button
                            variant="danger"
                            className="btn3d-danger"
                            onClick={this.OnCancelSale}
                          >
                            X
                          </Button>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  ""
                )}
              </tbody>
            </Table>
          </div>
        )}
      </>
    );
  }
}

export class PaymentTypeModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      loadSpinnerOpen: false,
      customerDetail: {
        id: "",
        firstName: "",
        emailId: "",
        mobileNo: "",
        address: "",
      },
      customerDeliveryDetail: {
        firstName: "",
        emailId: "",
        mobileNo: "",
        address: "",
      },
      tmobileNo: "",
      amountReceived: "",
      amountToReturn: "",
      reload: false,
      showCustomerDetails: false,
      ignoreCustomerData: false,
      deliverToBillingAddress: false,

      // Collapsible UI
      showBilling: true,
      showDelivery: false,

      // Loyalty state
      redeemPoints: 0,
      redeemValue: 0, // currency value for redeemed points
      maxRedeemablePoints: 0,
      pointsPerCurrency: 10, // default (100 points => 1 currency unit) — overwritten from storeSettings if present
      loyaltyEarnPreview: 0,
    };
  }

  // --- helpers
  digitsOnly = (value, maxLen = 10) => {
    const onlyDigits = (value || "").replace(/\D/g, "");
    return onlyDigits.slice(0, maxLen);
  };

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  componentDidMount = () => {
    document.addEventListener("keydown", this._handleNVEvent, false);
    const ctrl = document.getElementById("customernumber");
    if (ctrl) ctrl.focus();

    const ppc =
      (this.context.storeSettings &&
        this.context.storeSettings.pointsPerCurrency) ||
      (this.context.storeSettings &&
        this.context.storeSettings.points_per_currency) ||
      100;
    this.setState({ pointsPerCurrency: ppc });
  };

  componentWillUnmount = () => {
    try {
      document.removeEventListener("keydown", this._handleNVEvent);
    } catch {}
  };

  SaveUserProfile() {
    this.state.customerDetail.customerUserTypeId = 1;
    fetch(
      process.env.REACT_APP_API +
        "Consumers/UpdateUserAccount/" +
        this.context.storeId,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.state.customerDetail),
      }
    )
      .then((r) => r.json())
      .then((data) => {
        if (data.status == 404 || data.status == 400) {
          this.setState({ ResultStatusText: "Unable to Save. try later!" });
          return;
        }
        this.setState({
          customerDetail: data,
          ResultStatusText: "Saved Successfully!",
        });
        Swal.fire({
          icon: "success",
          title: "Customer saved",
          timer: 800,
          showConfirmButton: false,
        });

        // refresh loyalty data after update (if needed)
        this.afterCustomerLoaded(data);
      })
      .catch((error) => {
        console.error("Save error:", error);
        Swal.fire({
          icon: "error",
          title: "Save failed",
          text: String(error).slice(0, 120),
        });
      });
  }

  // handles many billing fields
  handleInputChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    switch (name.trim()) {
      case "amountReceived":
        this.setState({ amountReceived: value });
        this.setState({
          amountToReturn:
            this.context.getTotalAmountWithTax(
              this.context.getPOSCartByName(this.context.selectedPOS),
              this.props.coupon.couponValue
            ) - value,
        });
        break;
      case "firstName":
        this.state.customerDeliveryDetail.firstName = value;
        break;
      case "mobileNo":
        this.state.customerDeliveryDetail.mobileNo = this.digitsOnly(value, 10);
        break;
      case "emailId":
        this.state.customerDeliveryDetail.emailId = value;
        break;
      case "address":
        this.state.customerDeliveryDetail.address = value;
        break;
      case "country":
        this.state.customerDeliveryDetail.country = value;
        break;
      case "state":
        this.state.customerDeliveryDetail.state = value;
        break;
      case "city":
        this.state.customerDeliveryDetail.city = value;
        break;
      case "pinCode":
        this.state.customerDeliveryDetail.pinCode = value;
        break;
      case "gstno":
        this.state.customerDeliveryDetail.gstno = value;
        break;
      default:
        break;
    }
    this.setState({
      customerDeliveryDetail: this.state.customerDeliveryDetail,
    });
  };

  handleInputChangeForSignup = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    switch (name) {
      case "firstName":
        this.state.customerDetail.firstName = value;
        break;
      case "lastName":
        this.state.customerDetail.lastName = value;
        break;
      case "emailId":
        this.state.customerDetail.emailId = value;
        break;
      case "mobileNo":
        this.state.customerDetail.mobileNo = this.digitsOnly(value, 10);
        break;
      case "address":
        this.state.customerDetail.address = value;
        break;
      case "landmark":
        this.state.customerDetail.landmark = value;
        break;
      case "city":
        this.state.customerDetail.city = value;
        break;
      case "state":
        this.state.customerDetail.state = value;
        break;
      case "country":
        this.state.customerDetail.country = value;
        break;
      case "pinCode":
        this.state.customerDetail.pinCode = value;
        break;
      case "gstno":
        this.state.customerDetail.gstno = value;
        break;
      default:
        break;
    }
    this.setState({
      customerDetail: this.state.customerDetail,
      ResultStatusText: "",
    });
  };

  // ===== loyalty helpers =====
  computeAvailablePointsFromCustomer = (cust) => {
    if (!cust) return 0;
    const earned =
      Number(cust.totalLoyaltyPointEarned) ||
      Number(cust.TotalLoyaltyPointEarned) ||
      0;
    const redeemed =
      Number(cust.totalLoyaltyPointRedeemed) ||
      Number(cust.TotalLoyaltyPointRedeemed) ||
      0;
    const available = Math.max(0, earned - redeemed);
    return available;
  };

  computeEarnPreview = () => {
    try {
      const subTotal = this.context.getSubTotalPriceInCart(
        this.context.getPOSCartByName(this.context.selectedPOS)
      );
      return this.context.getLoyaltyPointsEarnable(subTotal);
    } catch {
      return 0;
    }
  };

  onRedeemPointsChanged = (val) => {
    let p = Number(val) || 0;
    const maxP = this.state.maxRedeemablePoints || 0;
    if (p < 0) p = 0;
    if (p > maxP) p = maxP;

    const redeemValue =
      Math.round((p / this.state.pointsPerCurrency) * 100) / 100;
    this.setState({ redeemPoints: p, redeemValue });
  };

  buildLoyaltyReference = () => {
    return `LOY-${
      this.context.storeId || "S"
    }-${new Date().getTime()}-${Math.floor(Math.random() * 9999)}`;
  };

  // ===== Payment flow =====
  ProcessPayment = () => {
    // if user updated profile, save it first
    if (this.state.showCustomerDetails === true) this.SaveUserProfile();

    // get billingCustomerId in a defensive way (server may return id or Id)
    const billingCustomerId =
      this.state.customerDetail?.id ||
      this.state.customerDetail?.Id ||
      this.state.customerDetail?.Id; // fallback, keep it explicit

    // prepare loyalty payload
    const pointsRedeemed = Number(this.state.redeemPoints) || 0;
    const loyaltyDiscountAmount = Number(this.state.redeemValue) || 0;
    const loyaltyReferenceId =
      pointsRedeemed > 0 ? this.buildLoyaltyReference() : "";

    const loyaltyPayload = {
      pointsRedeemed,
      loyaltyDiscountAmount,
      loyaltyReferenceId,
    };

    // call parent handlers with billingCustomerId (3rd param is loyalty payload)
    if (this.props.paymentType === "COD") {
      this.props.OnCodPaid(
        this.state.customerDeliveryDetail,
        billingCustomerId,
        loyaltyPayload
      );
    } else if (this.props.paymentType === "CASH") {
      this.props.OnCashPaid(
        this.state.customerDeliveryDetail,
        billingCustomerId,
        loyaltyPayload
      );
    } else if (this.props.paymentType === "QRCODE") {
      this.props.OnQrcodePaid(
        this.state.customerDeliveryDetail,
        billingCustomerId,
        loyaltyPayload
      );
    } else if (this.props.paymentType === "CARD") {
      this.props.OnCardSwipingMachineModalPaid(
        this.state.customerDeliveryDetail,
        billingCustomerId,
        loyaltyPayload
      );
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    // quick check: if redeeming more than available warn
    if (this.state.redeemPoints > (this.state.maxRedeemablePoints || 0)) {
      Swal.fire({
        icon: "warning",
        title: "Redeem points exceed available points",
        text: "Please reduce points to redeem.",
      });
      return;
    }
    this.ProcessPayment();
  };

  handleSubmitGstInvoice = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // --------- Validate customer mobile number ---------
    const mobile = (this.state.customerDetail?.mobileNo || "").replace(
      /\D/g,
      ""
    );
    if (mobile.length !== 10) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit customer mobile number.",
      });
      return;
    }

    // --------- Validate redeem points ---------
    const redeemPoints = Number(this.state.redeemPoints ?? 0);
    const maxPoints = Number(this.state.maxRedeemablePoints ?? 0);

    if (redeemPoints > maxPoints) {
      Swal.fire({
        icon: "warning",
        title: "Redeem points exceed available points",
        text: "Please reduce points to redeem.",
      });
      return;
    }

    // --------- Mark GST invoice request ---------
    this.props.SetGstInvoiceRequest(true);

    // --------- Process payment ---------
    this.ProcessPayment();
  };

  _handleNVEvent = (event) => {
    if (event.key === "Enter") {
      // if on search field and valid, trigger lookup
      if (
        document.activeElement?.id === "customernumber" &&
        this.state.tmobileNo.length === 10
      ) {
        event.preventDefault();
        this.GetCustomerAccountByMobileNo();
      }
    }
  };

  AmtToReturn = () => {
    if (!this.state.amountReceived) return 0;
    return Math.round((this.state.amountToReturn || 0) * -1, 0);
  };

  GetCustomerAccountByMobileNo = () => {
    if (!this.state.tmobileNo || this.state.tmobileNo.length !== 10) {
      Swal.fire({
        title: "Invalid MobileNo!",
        text: "Enter 10 digit valid Mobile number!",
        confirmButtonText: "ok",
      });
      return;
    }
    this.ShowLoadSpinner();
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetCustomerAccountByMobileNo/" +
        this.context.storeId +
        "/" +
        this.state.tmobileNo
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
          this.HideLoadSpinner();
        } else {
          this.setState(
            {
              showCustomerDetails: true,
              showBilling: true,
              showDelivery:
                this.context.GetSelectedPosOrderType() === "HomeDelivery",
              customerDetail: data,
            },
            () => {
              // set default countries from store settings
              this.state.customerDetail.country =
                this.state.customerDetail.country ||
                this.context.storeSettings.defaultCountry;
              this.setState({ customerDetail: this.state.customerDetail });

              this.state.customerDeliveryDetail.country =
                this.state.customerDeliveryDetail.country ||
                this.context.storeSettings.defaultCountry;
              this.setState({
                customerDeliveryDetail: this.state.customerDeliveryDetail,
              });

              // compute loyalty values
              this.afterCustomerLoaded(data);

              // Move caret to Billing first name
              setTimeout(() => {
                const el = document.getElementById("billing-firstname");
                if (el) el.focus();
              }, 0);
            }
          );
          this.HideLoadSpinner();
          Swal.fire({
            icon: "success",
            title: "Customer loaded",
            timer: 600,
            showConfirmButton: false,
          });
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        console.error("Fetch account error:", error);
      });
  };

  afterCustomerLoaded = (customerData) => {
    // compute available points
    const avail = this.computeAvailablePointsFromCustomer(customerData);
    const ppc =
      (this.context.storeSettings &&
        (this.context.storeSettings.pointsPerCurrency ||
          this.context.storeSettings.points_per_currency)) ||
      this.state.pointsPerCurrency ||
      100;

    // compute earn preview using context helper if available
    const earnPreview = this.computeEarnPreview();

    this.setState({
      maxRedeemablePoints: Math.floor(avail),
      pointsPerCurrency: ppc,
      loyaltyEarnPreview: earnPreview,
      // reset redeem fields when new customer loaded
      redeemPoints: 0,
      redeemValue: 0,
    });
  };

  render() {
    const phoneValid =
      (this.state.customerDetail?.mobileNo || "").toString().length === 10;

    // currency format helper (uses store settings)
    const renderMoney = (n, digits = 0) =>
      Number(n).toLocaleString(this.context.storeSettings.defaultLocale, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
        style: "currency",
        currency: this.context.storeSettings.defaultCurrency,
      });

    return (
      <>
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="xl"
          backdrop="static"
          keyboard={false}
          dialogClassName="payByCash"
        >
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.paymentType === "COD" && <>COD</>}
                {this.props.paymentType === "CASH" && <>Pay by Cash</>}
                {this.props.paymentType === "QRCODE" && <>Pay by QRCODE</>}
                {this.props.paymentType === "CARD" && <>Pay by CARD</>}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="show-grid m-0 p-0">
              {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : ""}

              <div className="px-3">
                {/* Step Indicator */}
                <div className="d-flex justify-content-center gap-3 my-3">
                  <Badge
                    bg={
                      this.state.showCustomerDetails ? "primary" : "secondary"
                    }
                  >
                    1. Customer
                  </Badge>
                  <Badge
                    bg={
                      this.context.GetSelectedPosOrderType() === "HomeDelivery"
                        ? "primary"
                        : "secondary"
                    }
                  >
                    2. Address
                  </Badge>
                  <Badge bg="primary">3. Payment</Badge>
                </div>

                {/* Summary Strip */}
                <Card className="mb-2">
                  <Card.Body className="py-2 d-flex justify-content-between">
                    <div>
                      <strong>Items:</strong>{" "}
                      {this.context.getTotalQtyInCart(
                        this.context.getPOSCartByName(this.context.selectedPOS)
                      )}
                    </div>
                    <div>
                      <strong>Total:</strong>{" "}
                      {Math.round(
                        this.context.getTotalAmountWithTax(
                          this.context.getPOSCartByName(
                            this.context.selectedPOS
                          ),
                          this.props.coupon.couponValue
                        ),
                        0
                      ).toLocaleString(
                        this.context.storeSettings.defaultLocale,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 1,
                          style: "currency",
                          currency: this.context.storeSettings.defaultCurrency,
                        }
                      )}
                    </div>
                    <div className="text-muted">
                      {this.props.coupon?.couponCode
                        ? `Coupon: ${this.props.coupon.couponCode} (-${this.props.coupon.couponValue})`
                        : "No Coupon"}
                    </div>
                  </Card.Body>
                </Card>
              </div>

              <Row
                className="m-0 p-0"
                style={{
                  overflowY: "scroll",
                  overflowX: "hidden",
                  minHeight: window.innerHeight - 240 + "px",
                  maxHeight: window.innerHeight - 240 + "px",
                }}
              >
                <Col className="text-center px-3">
                  <h4 className="mb-2">
                    <b>CHECKOUT</b>
                  </h4>
                  <hr className="mt-2" />

                  {/* Ignore number for in-store */}
                  {this.context.GetSelectedPosOrderType() === "InStore" ? (
                    <Form.Check
                      checked={this.state.ignoreCustomerData}
                      name="ignoreCustomerData"
                      label="Ignore Customer number"
                      className="text-primary text-start mx-1"
                      onChange={(e) =>
                        this.setState({
                          ignoreCustomerData: !!e.target.checked,
                        })
                      }
                    />
                  ) : null}

                  {/* Mobile number search */}
                  {this.state.ignoreCustomerData !== true ? (
                    <div className="border CornersRoundedSmall mt-3 bg-light p-3">
                      <Row className="w-100 border-0 p-0 m-0 g-2">
                        <Col className="border-0" md={7}>
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              id="customernumber"
                              name="tmobileNo"
                              maxLength={10}
                              value={this.state.tmobileNo}
                              required
                              placeholder="Enter Customer's MobileNo"
                              autoComplete="new-password"
                              inputMode="numeric"
                              pattern="\d*"
                              onChange={(e) =>
                                this.setState({
                                  tmobileNo: this.digitsOnly(
                                    e.target.value,
                                    10
                                  ),
                                })
                              }
                              onKeyDown={(e) => {
                                if (
                                  e.key === "Enter" &&
                                  this.state.tmobileNo.length === 10
                                ) {
                                  e.preventDefault();
                                  this.GetCustomerAccountByMobileNo();
                                }
                              }}
                              style={{ fontSize: "18px", paddingRight: 80 }}
                            />
                            <small
                              className="position-absolute top-50 translate-middle-y end-0 me-2"
                              style={{ fontWeight: "bold" }}
                            >
                              {this.state.tmobileNo.length === 10 ? (
                                <span className="text-success">✔ Valid</span>
                              ) : (
                                <span className="text-danger">✖ Invalid</span>
                              )}
                            </small>
                          </div>
                        </Col>
                        <Col className="border-0 d-grid" md={5}>
                          <Button
                            variant="primary"
                            size="lg"
                            disabled={this.state.tmobileNo.length !== 10}
                            onClick={this.GetCustomerAccountByMobileNo}
                          >
                            Get Customer Details
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ) : null}

                  {/* Billing & Delivery Sections (collapsible) */}
                  {this.state.showCustomerDetails ? (
                    <>
                      {/* Billing */}
                      <div className="border CornersRoundedSmall mt-3 bg-light p-3 text-start">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className="m-0">
                            <b>Billing Address</b>
                          </h5>
                          <div className="d-flex gap-2">
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() =>
                                this.setState({
                                  showBilling: !this.state.showBilling,
                                })
                              }
                            >
                              {this.state.showBilling ? "Hide" : "Show"}
                            </Button>
                            <Button
                              variant="success"
                              size="sm"
                              onClick={() => this.SaveUserProfile()}
                            >
                              {this.state.customerDetail.customerUserTypeId != 1
                                ? "Register Customer"
                                : "Update Customer"}
                            </Button>
                          </div>
                        </div>

                        {this.state.showBilling ? (
                          <>
                            <Row className="w-100 border-0 my-2">
                              <Col xs={12} md={6}>
                                <FloatingLabel
                                  controlId="billing-firstname"
                                  label="First Name *"
                                >
                                  <Form.Control
                                    id="billing-firstname"
                                    type="text"
                                    name="firstName"
                                    value={
                                      this.state.customerDetail.firstName || ""
                                    }
                                    required
                                    autoComplete="new-password"
                                    onChange={this.handleInputChangeForSignup}
                                  />
                                </FloatingLabel>
                              </Col>
                              <Col xs={12} md={6}>
                                <FloatingLabel label="Last Name">
                                  <Form.Control
                                    type="text"
                                    name="lastName"
                                    value={
                                      this.state.customerDetail.lastName || ""
                                    }
                                    onChange={this.handleInputChangeForSignup}
                                  />
                                </FloatingLabel>
                              </Col>
                            </Row>

                            <Row className="w-100 border-0 my-2">
                              <Col xs={12} md={6}>
                                <FloatingLabel label="Contact Number *">
                                  <Form.Control
                                    type="text"
                                    name="mobileNo"
                                    inputMode="numeric"
                                    pattern="\d*"
                                    maxLength={10}
                                    value={
                                      this.state.customerDetail.mobileNo || ""
                                    }
                                    required
                                    autoComplete="new-password"
                                    onChange={(e) => {
                                      e.target.value = this.digitsOnly(
                                        e.target.value,
                                        10
                                      );
                                      this.handleInputChangeForSignup(e);
                                    }}
                                  />
                                  <small className="position-absolute top-50 translate-middle-y end-0 me-2">
                                    {phoneValid ? (
                                      <span className="text-success">✔</span>
                                    ) : (
                                      <span className="text-danger">✖</span>
                                    )}
                                  </small>
                                </FloatingLabel>
                              </Col>
                              <Col xs={12} md={6}>
                                <FloatingLabel label="Email ID">
                                  <Form.Control
                                    type="email"
                                    name="emailId"
                                    value={
                                      this.state.customerDetail.emailId || ""
                                    }
                                    onChange={this.handleInputChangeForSignup}
                                  />
                                </FloatingLabel>
                              </Col>
                            </Row>

                            <Row className="w-100 border-0 my-2">
                              <Col xs={12} md={4}>
                                <FloatingLabel label="Country *">
                                  <Form.Select
                                    value={
                                      this.state.customerDetail.country || ""
                                    }
                                    name="country"
                                    required
                                    disabled
                                    onChange={this.handleInputChangeForSignup}
                                  >
                                    <option value=""></option>
                                    {Country.getAllCountries().map((c) => (
                                      <option key={c.isoCode} value={c.isoCode}>
                                        {c.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </FloatingLabel>
                              </Col>
                              <Col xs={12} md={4}>
                                <FloatingLabel
                                  label={
                                    window.location.hostname ===
                                    "green.elasticcart.com"
                                      ? "Province *"
                                      : "State"
                                  }
                                >
                                  <Form.Select
                                    value={
                                      this.state.customerDetail.state || ""
                                    }
                                    name="state"
                                    disabled={
                                      this.context.storeSettings
                                        .disableStateSelection
                                    }
                                    onChange={this.handleInputChangeForSignup}
                                  >
                                    <option></option>
                                    {State.getStatesOfCountry(
                                      this.state.customerDetail.country
                                    ).map((s) => (
                                      <option key={s.isoCode}>{s.name}</option>
                                    ))}
                                  </Form.Select>
                                </FloatingLabel>
                              </Col>
                              <Col xs={12} md={4}>
                                <FloatingLabel label="City">
                                  <Form.Control
                                    type="text"
                                    name="city"
                                    value={this.state.customerDetail.city || ""}
                                    onChange={this.handleInputChangeForSignup}
                                  />
                                </FloatingLabel>
                              </Col>
                            </Row>

                            <Row className="w-100 border-0 my-2">
                              <Col xs={12}>
                                <FloatingLabel label="Address">
                                  <Form.Control
                                    type="text"
                                    name="address"
                                    value={
                                      this.state.customerDetail.address || ""
                                    }
                                    onChange={this.handleInputChangeForSignup}
                                  />
                                </FloatingLabel>
                              </Col>
                            </Row>

                            <Row className="w-100 border-0 my-2">
                              <Col xs={12} md={4}>
                                <FloatingLabel label="PinCode">
                                  <Form.Control
                                    type="text"
                                    name="pinCode"
                                    minLength={
                                      this.context.storeSettings.pincodeLength
                                    }
                                    maxLength={
                                      this.context.storeSettings.pincodeLength
                                    }
                                    value={
                                      this.state.customerDetail.pinCode || ""
                                    }
                                    onChange={this.handleInputChangeForSignup}
                                  />
                                </FloatingLabel>
                              </Col>
                              <Col xs={12} md={8}>
                                <FloatingLabel label="GSTIN">
                                  <Form.Control
                                    type="text"
                                    name="gstno"
                                    value={
                                      this.state.customerDetail.gstno || ""
                                    }
                                    onChange={this.handleInputChangeForSignup}
                                  />
                                </FloatingLabel>
                              </Col>
                            </Row>

                            {this.context.GetSelectedPosOrderType() ===
                            "HomeDelivery" ? (
                              <Form.Check
                                checked={this.state.deliverToBillingAddress}
                                name="deliverytype"
                                label="Deliver to this Address"
                                className="text-primary"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    this.setState((prev) => ({
                                      deliverToBillingAddress: true,
                                      showDelivery: false,
                                      customerDeliveryDetail: {
                                        ...prev.customerDetail,
                                        mobileNo:
                                          prev.customerDetail.mobileNo ||
                                          prev.customerDeliveryDetail
                                            .mobileNo ||
                                          "",
                                      },
                                    }));
                                  } else {
                                    this.setState({
                                      deliverToBillingAddress: false,
                                      showDelivery: true,
                                    });
                                  }
                                }}
                              />
                            ) : null}
                          </>
                        ) : null}
                      </div>

                      {/* Delivery */}
                      {this.context.GetSelectedPosOrderType() ===
                        "HomeDelivery" &&
                      !this.state.deliverToBillingAddress ? (
                        <div className="border CornersRoundedSmall mt-3 bg-light p-3 text-start">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">
                              <b>Delivery Address</b>
                            </h5>
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() =>
                                this.setState({
                                  showDelivery: !this.state.showDelivery,
                                })
                              }
                            >
                              {this.state.showDelivery ? "Hide" : "Show"}
                            </Button>
                          </div>

                          {this.state.showDelivery ? (
                            <>
                              <Row className="w-100 border-0 my-2">
                                <Col>
                                  <FloatingLabel label="Name *">
                                    <Form.Control
                                      type="text"
                                      name="firstName"
                                      value={
                                        this.state.customerDeliveryDetail
                                          .firstName || ""
                                      }
                                      required
                                      onChange={this.handleInputChange}
                                    />
                                  </FloatingLabel>
                                </Col>
                              </Row>

                              <Row className="w-100 border-0 my-2">
                                <Col>
                                  <FloatingLabel label="Contact Number *">
                                    <Form.Control
                                      type="text"
                                      name="mobileNo"
                                      inputMode="numeric"
                                      pattern="\d*"
                                      maxLength={10}
                                      value={
                                        this.state.customerDeliveryDetail
                                          .mobileNo || ""
                                      }
                                      required
                                      onChange={(e) => {
                                        e.target.value = this.digitsOnly(
                                          e.target.value,
                                          10
                                        );
                                        this.handleInputChange(e);
                                      }}
                                    />
                                  </FloatingLabel>
                                </Col>
                                <Col>
                                  <FloatingLabel label="Email ID">
                                    <Form.Control
                                      type="email"
                                      name="emailId"
                                      value={
                                        this.state.customerDeliveryDetail
                                          .emailId || ""
                                      }
                                      onChange={this.handleInputChange}
                                    />
                                  </FloatingLabel>
                                </Col>
                              </Row>

                              <Row className="w-100 border-0 my-2">
                                <Col>
                                  <FloatingLabel label="Country *">
                                    <Form.Select
                                      value={
                                        this.state.customerDeliveryDetail
                                          .country || ""
                                      }
                                      name="country"
                                      required
                                      disabled
                                      onChange={this.handleInputChange}
                                    >
                                      <option value=""></option>
                                      {Country.getAllCountries().map((c) => (
                                        <option
                                          key={c.isoCode}
                                          value={c.isoCode}
                                        >
                                          {c.name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </FloatingLabel>
                                </Col>
                                <Col>
                                  <FloatingLabel
                                    label={
                                      window.location.hostname ===
                                      "green.elasticcart.com"
                                        ? "Province *"
                                        : "State"
                                    }
                                  >
                                    <Form.Select
                                      value={
                                        this.state.customerDeliveryDetail
                                          .state || ""
                                      }
                                      name="state"
                                      disabled={
                                        this.context.storeSettings
                                          .disableStateSelection
                                      }
                                      onChange={this.handleInputChange}
                                    >
                                      <option></option>
                                      {State.getStatesOfCountry(
                                        this.state.customerDeliveryDetail
                                          .country
                                      ).map((s) => (
                                        <option key={s.isoCode}>
                                          {s.name}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </FloatingLabel>
                                </Col>
                                <Col>
                                  <FloatingLabel label="City">
                                    <Form.Control
                                      type="text"
                                      name="city"
                                      value={
                                        this.state.customerDeliveryDetail
                                          .city || ""
                                      }
                                      onChange={this.handleInputChange}
                                    />
                                  </FloatingLabel>
                                </Col>
                              </Row>

                              <Row className="w-100 border-0 my-2">
                                <Col>
                                  <FloatingLabel label="Address">
                                    <Form.Control
                                      type="text"
                                      name="address"
                                      value={
                                        this.state.customerDeliveryDetail
                                          .address || ""
                                      }
                                      onChange={this.handleInputChange}
                                    />
                                  </FloatingLabel>
                                </Col>
                              </Row>

                              <Row className="w-100 border-0 my-2">
                                <Col md={4}>
                                  <FloatingLabel label="PinCode">
                                    <Form.Control
                                      type="text"
                                      name="pinCode"
                                      minLength={
                                        this.context.storeSettings.pincodeLength
                                      }
                                      maxLength={
                                        this.context.storeSettings.pincodeLength
                                      }
                                      value={
                                        this.state.customerDeliveryDetail
                                          .pinCode || ""
                                      }
                                      onChange={this.handleInputChange}
                                    />
                                  </FloatingLabel>
                                </Col>
                                <Col md={8}>
                                  <FloatingLabel label="GSTIN">
                                    <Form.Control
                                      type="text"
                                      name="gstno"
                                      value={
                                        this.state.customerDeliveryDetail
                                          .gstno || ""
                                      }
                                      onChange={this.handleInputChange}
                                    />
                                  </FloatingLabel>
                                </Col>
                              </Row>
                            </>
                          ) : null}
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  {/* Loyalty UI: show when customer details loaded */}
                  {this.context.storeSettings.showLoyaltyPointsModule ===
                    true && this.state.showCustomerDetails ? (
                    <Card className="mt-3 mb-3">
                      <Card.Body>
                        <Row>
                          <Col>
                            <strong>Available Loyalty Points:</strong>{" "}
                            {this.state.maxRedeemablePoints}
                          </Col>
                          <Col>
                            <strong>Will Earn (this order):</strong>{" "}
                            {this.state.loyaltyEarnPreview}
                          </Col>
                        </Row>

                        <Row className="mt-2 align-items-center">
                          <Col md={6}>
                            <Form.Label>Redeem Points</Form.Label>
                            <Form.Control
                              type="number"
                              min={0}
                              step={1}
                              value={this.state.redeemPoints}
                              onChange={(e) =>
                                this.onRedeemPointsChanged(e.target.value)
                              }
                            />
                            <small className="text-muted">
                              1 {this.context.storeSettings.pointsLabel || "pt"}{" "}
                              = {1 / this.state.pointsPerCurrency}{" "}
                              {this.context.storeSettings.defaultCurrency ||
                                "₹"}{" "}
                              (points per currency:{" "}
                              {this.state.pointsPerCurrency})
                            </small>
                          </Col>
                          <Col md={6}>
                            <Form.Label>Redeem Value</Form.Label>
                            <div
                              style={{ fontSize: "18px", fontWeight: "700" }}
                            >
                              {renderMoney(this.state.redeemValue, 2)}
                            </div>
                            <div className="text-muted">
                              Will be applied as discount on this order
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ) : null}

                  {/* Payment-specific sections remain below */}
                  <div className="CornersRoundedSmall py-3">
                    {this.props.paymentType === "CASH" ? (
                      <div
                        className="border CornersRoundedSmall p-3"
                        style={{ backgroundColor: "cyan" }}
                      >
                        <h5 className="text-dark mb-3">
                          <b>To be Paid</b>
                        </h5>
                        <table className="w-100">
                          <tbody>
                            <tr>
                              <td width="50%">
                                <Form.Label>
                                  <h5>Bill Amount:</h5>
                                </Form.Label>
                              </td>
                              <td width="50%">
                                <Form.Label>
                                  <h5>
                                    {Math.round(
                                      this.context.getTotalAmountWithTax(
                                        this.context.getPOSCartByName(
                                          this.context.selectedPOS
                                        ),
                                        this.props.coupon.couponValue
                                      ),
                                      0
                                    ).toLocaleString(
                                      this.context.storeSettings.defaultLocale,
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 1,
                                        style: "currency",
                                        currency:
                                          this.context.storeSettings
                                            .defaultCurrency,
                                      }
                                    )}
                                  </h5>
                                </Form.Label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <Form.Label>
                                  <h5>Received:</h5>
                                </Form.Label>
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  size="lg"
                                  id="amountReceived"
                                  name="amountReceived"
                                  value={this.state.amountReceived}
                                  autoComplete="new-password"
                                  onChange={this.handleInputChange}
                                  style={{ fontSize: "26px" }}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="verticalaligncentertd">
                                <Form.Label className="my-">
                                  <h5>Amount to Return:</h5>
                                </Form.Label>
                              </td>
                              <td>
                                <Form.Label className="my-3">
                                  <h3 className="bg-danger text-white px-2">
                                    {this.AmtToReturn().toLocaleString(
                                      this.context.storeSettings.defaultLocale,
                                      {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 1,
                                        style: "currency",
                                        currency:
                                          this.context.storeSettings
                                            .defaultCurrency,
                                      }
                                    )}
                                  </h3>
                                </Form.Label>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : null}

                    {this.props.paymentType === "QRCODE" ? (
                      <div className="border p-3 bg-light">
                        <table className="w-100">
                          <tbody>
                            <tr className="text-center align-middle">
                              <td className="col-md-12 text-center">
                                <h5>
                                  <b>
                                    Bill Total Amount:&nbsp;
                                    {Math.round(
                                      this.context.getTotalAmountWithTax(
                                        this.context.getPOSCartByName(
                                          this.context.selectedPOS
                                        ),
                                        this.props.coupon.couponValue
                                      ),
                                      0
                                    )}
                                  </b>
                                </h5>
                              </td>
                            </tr>
                            <tr className="text-center align-middle">
                              <td className="col-md-12">
                                <img
                                  src={
                                    this.context.store.storageBlobUrl +
                                    this.context.store
                                      .storageBlobContainerName +
                                    "/images/qrcode.png" +
                                    this.context.store.storageSasToken
                                  }
                                  className="mx-auto"
                                  alt="..."
                                  style={{ width: "5cm" }}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : null}

                    {this.props.paymentType === "CARD" ? (
                      <div className="border p-3 bg-light">
                        <table className="w-100">
                          <tbody>
                            <tr className="text-center align-middle">
                              <td className="col-md-12 text-center">
                                <h5>
                                  <b>
                                    Bill Total Amount:&nbsp;
                                    {Math.round(
                                      this.context.getTotalAmountWithTax(
                                        this.context.getPOSCartByName(
                                          this.context.selectedPOS
                                        ),
                                        this.props.coupon.couponValue
                                      ),
                                      0
                                    )}
                                  </b>
                                </h5>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : null}
                  </div>
                </Col>

                {/* Order summary stays as-is but we pass loyalty props into it */}
                <Col className="text-dark CornersRoundedSmall border bg-light p-3">
                  <OrderSummary
                    coupon={this.props.coupon}
                    StoreCouponDetails={this.props.StoreCouponDetails}
                    myCart={this.context.getPOSCartByName(
                      this.context.selectedPOS
                    )}
                    homeDelivery={true}
                    showLoyaltySection={false} // keep summary unchanged — loyalty UI shown in left panel
                    // you can change this to true if you moved loyalty UI inside OrderSummary
                    maxRedeemablePoints={this.state.maxRedeemablePoints}
                    redeemPoints={this.state.redeemPoints}
                    redeemValue={this.state.redeemValue}
                    onRedeemPointsChanged={(val) =>
                      this.onRedeemPointsChanged(val)
                    }
                  />
                  <div className="col-md-12 border-light border ">
                    <h4 className="text-dark text-center ">
                      <b>Items in Cart</b>
                    </h4>
                    <OrderedItems
                      myCart={this.context.getPOSCartByName(
                        this.context.selectedPOS
                      )}
                    />
                    <br />
                    <br />
                  </div>
                </Col>
              </Row>
            </Modal.Body>

            {/* Sticky footer for primary actions */}
            <Modal.Footer
              className="bg-light"
              style={{
                position: "sticky",
                bottom: 0,
                zIndex: 5,
              }}
            >
              <Button variant="primary" type="submit" size="lg">
                Print Invoice & Complete Order
              </Button>
              <Button
                variant="success"
                type="submit"
                onClick={(e) => {
                  // Prevent bubbling to the form submit handler immediately
                  e.preventDefault && e.preventDefault();
                  e.stopPropagation && e.stopPropagation();
                  if (
                    e.nativeEvent &&
                    typeof e.nativeEvent.stopImmediatePropagation === "function"
                  ) {
                    try {
                      e.nativeEvent.stopImmediatePropagation();
                    } catch {}
                  }
                  // then call your handler
                  this.handleSubmitGstInvoice(e);
                }}
                size="lg"
              >
                Print GST Invoice & Complete Order
              </Button>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  }
}

export class OrderSummary extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      couponCode: "",
      couponValue: 0,
      couponData: "",
    };
  }

  ValidateCoupon = (data) => {
    if (data.mainCategoryId) {
      const cart = this.context.getPOSCartByName(this.context.selectedPOS);
      const result = cart.filter(
        (f) => f.prod.mainCategoryId === data.mainCategoryId
      );
      return result.length === cart.length;
    }
    return true;
  };

  StoreCouponDetails = (data) => {
    if (!this.ValidateCoupon(data)) {
      Swal.fire({
        title: "Information!",
        confirmButtonColor: "#23B14D",
        text: "We are Sorry! This coupon can't be applied",
        confirmButtonText: "Ok",
      });
      this.setState({ couponCode: "" });
      return;
    }

    this.setState({ couponData: data }, () => {
      const cartSubTotal = this.context.getSubTotalPriceInCart(
        this.context.getPOSCartByName(this.context.selectedPOS)
      );

      // Type 1: absolute amount
      if (this.state.couponData.couponValueType === 1) {
        if (this.state.couponData.amount > cartSubTotal) {
          Swal.fire({
            title: "Information!",
            confirmButtonColor: "#23B14D",
            text:
              "Coupon Value is " +
              this.state.couponData.amount +
              " which is greater than items in Cart. Add more items to Cart to use this Coupon!",
            confirmButtonText: "Ok",
          });
          this.setState({ couponCode: "" });
          return;
        }
        this.setState(
          { couponValue: Math.round(this.state.couponData.amount) },
          () => {
            this.props.StoreCouponDetails(
              this.state.couponCode,
              this.state.couponValue
            );
          }
        );
      }
      // Type 2: percentage
      else if (this.state.couponData.couponValueType === 2) {
        const val = Math.round(
          (cartSubTotal * this.state.couponData.discount) / 100
        );
        if (this.state.couponData.discount > cartSubTotal) {
          Swal.fire({
            title: "Information!",
            confirmButtonColor: "#23B14D",
            text:
              "Coupon Value is " +
              this.state.couponData.discount +
              " which is greater than items in Cart. Add more items to Cart to use this Coupon!",
            confirmButtonText: "Ok",
          });
          this.setState({ couponCode: "" });
          return;
        }
        this.setState({ couponValue: val }, () => {
          this.props.StoreCouponDetails(
            this.state.couponCode,
            this.state.couponValue
          );
        });
      }
    });
  };

  OnClickCouponApply = () => {
    if (!this.state.couponCode?.trim()) return;
    fetch(
      process.env.REACT_APP_API +
        "Consumers/GetCoupon/" +
        this.context.storeId +
        "/" +
        this.state.couponCode
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 404) {
          Swal.fire({
            title: "Information!",
            confirmButtonColor: "#23B14D",
            text: "This is an Invalid Coupon Code!",
            confirmButtonText: "Ok",
          });
          this.setState({ couponCode: "" });
          return;
        }
        this.StoreCouponDetails(data);
      })
      .catch((error) => {
        console.error("OnClickCouponApply error!", error);
      });
  };

  onCouponCodeChange = (e) => {
    const val = e.target.value;
    this.setState({ couponCode: val, couponValue: 0 });
    // reset in context immediately
    this.context.StoreCouponDetails(val, 0);
  };

  removeCoupon = () => {
    this.setState({ couponCode: "", couponValue: 0, couponData: "" });
    this.props.StoreCouponDetails("", 0);
  };

  renderMoney = (n, digits = 0) =>
    Number(n).toLocaleString(this.context.storeSettings.defaultLocale, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      style: "currency",
      currency: this.context.storeSettings.defaultCurrency,
    });

  componentDidMount = () => {};

  render() {
    const cart = this.context.getPOSCartByName(this.context.selectedPOS);
    const subTotal = this.context.getSubTotalPriceInCart(cart);
    const delivery = Number(this.context.getDeliveryAmount(cart));
    const taxExc = this.context.taxDetails.inclusiveOfTax !== true;
    const taxAmount = taxExc
      ? this.context.getTaxAmount(cart, this.state.couponValue)
      : 0;

    // total before loyalty redemption (current behaviour)
    const totalBeforeLoyalty = this.context.getTotalAmountWithTax(
      cart,
      this.state.couponValue
    );

    // read redeem props (parent should pass redeemPoints/redeemValue)
    const redeemPoints = Number(this.props.redeemPoints || 0);
    const redeemValue = Number(this.props.redeemValue || 0);

    // final total after applying redeem value
    const total = Math.max(0, Number(totalBeforeLoyalty) - redeemValue);

    const savings = this.context.getTotalSavingsFromCart(cart);

    return (
      <>
        <Row className="my-2 mx-0 order-summary">
          <h4 className="text-left text-dark px-0">
            <b>Order Summary</b>
          </h4>
        </Row>

        <div className="text-dark order-details">
          <Row className="py-1">
            <Col className="text-start">
              Sub Total [{this.context.getTotalQtyInCart(cart)} Items] :
            </Col>
            <Col xs={3} className="text-end">
              {this.renderMoney(subTotal)}
            </Col>
          </Row>

          <Row className="py-1">
            <Col className="text-start">Delivery/Shipping charges :</Col>
            <Col xs={3}>
              <Form.Control
                type="text"
                value={this.context.deliveryCost}
                className="text-end"
                onChange={(e) => {
                  if (Number(e.target.value) >= 0)
                    this.context.setDeliveryCost(e.target.value);
                }}
              ></Form.Control>
            </Col>
          </Row>

          {taxExc && (
            <Row className="py-1">
              <Col className="text-start">
                Tax ({this.context.taxDetails.taxPercentage}%):
              </Col>
              <Col className="text-end">+ {this.renderMoney(taxAmount)}</Col>
            </Row>
          )}

          <hr />

          {/* Show coupon row if present */}
          {this.state.couponValue > 0 && (
            <Row className="py-1 align-items-center">
              <Col className="text-start">
                <b>Coupon "{this.state.couponCode}" value :</b>
              </Col>
              <Col className="text-end">
                {this.renderMoney(this.state.couponValue)}
              </Col>
            </Row>
          )}

          {/* Redeem rows: points and value */}
          {(redeemPoints > 0 || redeemValue > 0) && (
            <>
              <Row className="py-1">
                <Col className="text-start">Redeem Points :</Col>
                <Col className="text-end">{redeemPoints}</Col>
              </Row>

              <Row className="py-1">
                <Col className="text-start">Redeem Value :</Col>
                <Col className="text-end">
                  - {this.renderMoney(redeemValue)}
                </Col>
              </Row>
            </>
          )}

          <Row className="py-1 my-2">
            <Col className="text-start total-text">
              <h4 className=""> Total :</h4>
            </Col>
            <Col className="text-end">
              <h4>
                <b>{this.renderMoney(total)}</b>
                <br />
                <small style={{ fontSize: "11px" }}>
                  {this.context.taxDetails.inclusiveOfTax === true
                    ? "(Inclusive of Tax)"
                    : ""}
                </small>
              </h4>
            </Col>
          </Row>

          <Row className="py-0 ">
            <Col className="text-start">Total Savings :</Col>
            <Col className="text-end">
              {this.renderMoney(
                savings + redeemValue + (this.state.couponValue || 0)
              )}
            </Col>
          </Row>

          {this.context.storeSettings.hideCouponCodeField ? null : (
            <>
              <Row className="my-1 ">
                <Col>
                  Coupon Code (if any):
                  <Stack direction="horizontal" gap={2}>
                    <Form.Control
                      type="text"
                      placeholder=""
                      className="bg-white mx-3"
                      value={this.state.couponCode}
                      size="lg"
                      onChange={this.onCouponCodeChange}
                    />
                    <Button
                      size="lg"
                      disabled={!this.state.couponCode?.trim()}
                      style={{
                        backgroundColor:
                          this.context.theme.mainNavBarBackgroundColor,
                        color: this.context.theme.mainNavBarTextColor,
                      }}
                      onClick={this.OnClickCouponApply}
                    >
                      Apply
                    </Button>
                  </Stack>
                </Col>
              </Row>

              {this.state.couponValue > 0 && (
                <Row className="py-1 align-items-center">
                  <Col className="text-start">
                    <b>Coupon "{this.state.couponCode}" value :</b>
                    <Button
                      variant="link"
                      className="p-0 ms-2"
                      onClick={this.removeCoupon}
                    >
                      Remove
                    </Button>
                  </Col>
                  <Col className="text-end">
                    <h5>{this.renderMoney(this.state.couponValue)}</h5>
                  </Col>
                </Row>
              )}
            </>
          )}

          <Row>
            <div className="text-center note-text">
              {this.context.shippingDetails.freeDelivery === true &&
              this.context.deliveryMethod === "HomeDelivery" ? (
                <>Free Delivery</>
              ) : this.context.shippingDetails.deliveryCharges === true &&
                this.context.deliveryMethod === "HomeDelivery" ? (
                <>
                  Free Shipping/Delivery above{" "}
                  {this.renderMoney(
                    this.context.shippingDetails.freeDeliveryAbove
                  )}
                </>
              ) : null}
            </div>
          </Row>
        </div>
        <br />
        <br />
      </>
    );
  }
}

export class OrderedItems extends Component {
  static contextType = CartContext;

  GetProductNameDetailed = (prod) => {
    let result = prod.name;
    if (prod.hsncode) result += " HSNCode: " + prod.hsncode;
    if (prod.batchId) result += " BatchId: " + prod.batchId;
    if (prod.qualityId) result += " QualityId: " + prod.qualityId;
    return result;
  };

  renderMoney = (n) =>
    Math.round(Number(n), 0).toLocaleString(
      this.context.storeSettings.defaultLocale,
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: this.context.storeSettings.defaultCurrency,
      }
    );

  render() {
    const { myCart } = this.props;
    const { mainCategories } = this.context;

    return (
      <div className="mx-0 pt-3 border-0 ">
        {mainCategories.map((maincategory) => {
          const items = myCart.filter(
            (item) => item.prod.mainCategoryId === maincategory.id
          );
          if (items.length === 0) return null;

          return (
            <div key={maincategory.id} className="mx-0 px-0">
              <div className="row px-0 ">
                <h5 className="text-dark ">
                  <b>
                    <strong>{maincategory.name}</strong>
                  </b>
                </h5>
                <div className="px-3 ">
                  <Table
                    border="true"
                    className="cartviewtableOnCheckout px-5"
                    responsive="md"
                  >
                    <thead>
                      <tr className="text-center">
                        <th width="45%"></th>
                        <th width="10%">Price</th>
                        <th width="10%">Disc</th>
                        <th width="10%" className="text-center">
                          Qty/WT
                        </th>
                        <th width="10%" className="text-center">
                          Unit
                        </th>
                        {window.location.hostname ===
                        "sharoffsteel-pos.elasticcart.com" ? (
                          <th width="10%">Pieces</th>
                        ) : null}
                        <th width="25%" className="text-center">
                          Sub Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((cartitem, idx) => {
                        const priceAfterDisc =
                          cartitem.prod.mrp -
                          (cartitem.prod.mrp * cartitem.prod.discount) / 100;
                        const subtotal = cartitem.qty * priceAfterDisc;
                        const savings =
                          cartitem.qty *
                          ((cartitem.prod.mrp * cartitem.prod.discount) / 100);

                        return (
                          <tr className="text-center align-top" key={idx}>
                            <td className="text-start">
                              {this.GetProductNameDetailed(cartitem.prod)}
                            </td>
                            <td>
                              {Number(cartitem.prod.mrp).toLocaleString(
                                this.context.storeSettings.defaultLocale,
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                  style: "currency",
                                  currency:
                                    this.context.storeSettings.defaultCurrency,
                                }
                              )}
                            </td>
                            <td>{cartitem.prod.discount}%</td>
                            <td>{cartitem.qty}</td>
                            <td>{cartitem.prod.unit}</td>
                            {window.location.hostname ===
                            "sharoffsteel-pos.elasticcart.com" ? (
                              <td>{cartitem.pieceCount}</td>
                            ) : null}
                            <td className="text-center">
                              <b>{this.renderMoney(subtotal)}</b>
                              <br />
                              <span style={{ fontSize: "12px" }}>
                                Savings:&nbsp;{this.renderMoney(savings)}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
